import { CancelFunc, emptyCancel } from 'lib/cancel'
import { CreateReturn, GetReturn } from 'lib/rpc'
import { unaryInvoke } from 'lib/rpcts'
import {
    AuthBackend,
    GetTenantRequest,
    ListAuthBackendsRequest,
    ListAuthBackendsResponse,
    SignupRequest,
    SignupResponse,
    Tenant,
} from 'pbts/c1/api/accounts/v1/accounts'
import { AccountsClient } from 'pbts/c1/api/accounts/v1/accounts.client'
import { Dispatch } from 'react'

export enum AccountsAction {
    get = 'AccountsAction.get',
    signup = 'AccountsAction.signup',
    authbackends = 'AccountsAction.authbackends',
}

export type GetAction = {
    type: AccountsAction.get
    payload: GetReturn<Tenant>
}

export type SignupAction = {
    type: AccountsAction.signup
    payload: CreateReturn<SignupResponse>
}

export type AuthBackendsAction = {
    type: AccountsAction.authbackends
    payload: GetReturn<ListAuthBackendsResponse>
}

export type AccountsActions = GetAction | SignupAction | AuthBackendsAction

export const signup = (
    dispatch: Dispatch<AccountsActions>,
    client: AccountsClient | undefined,
    domain: string,
    displayName: string,
    inviteCode: string,
    acceptedTerms: boolean,
    authBackend: AuthBackend,
): CancelFunc => {
    if (!client) {
        return emptyCancel
    }

    const req = SignupRequest.create({
        domain,
        displayName,
        inviteCode,
        acceptedTerms,
        authBackend,
    })

    return unaryInvoke<SignupRequest, SignupResponse>(req, client.signup.bind(client), (payload) => {
        dispatch({
            type: AccountsAction.signup,
            payload,
        })
    })
}

export const listAuthBackends = (
    dispatch: Dispatch<AuthBackendsAction>,
    client: AccountsClient | undefined,
): CancelFunc => {
    if (!client) {
        return emptyCancel
    }

    const req = ListAuthBackendsRequest.create({})
    return unaryInvoke<ListAuthBackendsRequest, ListAuthBackendsResponse>(
        req,
        client.listAuthBackends.bind(client),
        (payload) => {
            dispatch({
                type: AccountsAction.authbackends,
                payload,
            })
        },
    )
}

export const getTenant = (
    dispatch: Dispatch<AccountsActions>,
    client: AccountsClient | undefined,
    name: string,
): CancelFunc | undefined => {
    if (!client) {
        return
    }

    const req = GetTenantRequest.create({
        name,
    })
    return unaryInvoke<GetTenantRequest, Tenant>(req, client.getTenant.bind(client), (payload) => {
        dispatch({
            type: AccountsAction.get,
            payload,
        })
    })
}
